module.exports = "/packs/images/svg/ireland/facilities/court~5b0acf03fc4d2be65707c76bd3c1f248.svg";